import React, { useEffect, useState } from "react";

import MuiDialog from "@mui/material/Dialog";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import SchoolIcon from "@mui/icons-material/School";
import {
  formatStartDate,
  getBatchScheduleDayTimeLabels,
  getEarliestStartDate,
  getStartDateStatus,
} from "utils/batchPreferenceUtils";

import styles from "./BatchPreference.module.scss";

const ConfirmBatchModal = ({
  open,
  programName,
  batch,
  isPending,
  onCancel,
  onConfirm,
}) => {
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const earliestStartDate = getEarliestStartDate(batch?.startDates || []);

  useEffect(() => {
    setSelectedStartDate("");
  }, [batch]);

  const handleClose = () => {
    if (isPending) return;
    setSelectedStartDate("");
    onCancel();
  };

  if (!batch) return null;

  const dayTimeLabels = getBatchScheduleDayTimeLabels(batch);

  return (
    <MuiDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-batch-title"
      PaperProps={{
        sx: {
          width: "560px",
          maxWidth: "95vw",
          maxHeight: "90vh",
          borderRadius: "14px",
          overflow: "hidden",
        },
      }}
    >
      <div className={styles.confirmModal}>
        <div className={styles.confirmModalHeader}>
          <div className={styles.confirmModalTitleWrap}>
            <EventAvailableIcon className={styles.confirmModalTitleIcon} />
            <h2 id="confirm-batch-title" className={styles.confirmModalTitle}>
              Confirm Batch
            </h2>
          </div>
        </div>

        <div className={styles.confirmModalBody}>
          <div className={styles.confirmProgramCard}>
            <div className={styles.confirmProgramHeader}>
              <SchoolIcon className={styles.confirmProgramIcon} />
              <p className={styles.confirmProgramName}>{programName}</p>
            </div>
            <div className={styles.scheduleLabelsRow}>
              {dayTimeLabels.map((dayTimeLabel, index) => (
                <span key={`${index}-${dayTimeLabel}`} className={styles.scheduleLabel}>
                  {dayTimeLabel}
                </span>
              ))}
            </div>
          </div>

          <p className={styles.confirmGuidance}>
            Please review the schedule and start date carefully before
            confirming.
          </p>

          <div className={styles.startDateList}>
            {(batch.startDates || []).map((startDate) => {
              const isSelected = selectedStartDate === startDate;
              const isFillingFast = earliestStartDate === startDate;

              return (
                <label
                  key={startDate}
                  className={`${styles.startDateOption} ${
                    isSelected ? styles.startDateOptionSelected : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="batch-start-date"
                    value={startDate}
                    checked={isSelected}
                    onChange={() => setSelectedStartDate(startDate)}
                  />
                  <span className={styles.startDateOptionText}>
                    {formatStartDate(startDate)} ·{" "}
                    {getStartDateStatus(startDate)}
                  </span>
                  {isFillingFast ? (
                    <span className={styles.fillingFastOrange}>
                      <LocalFireDepartmentIcon
                        className={styles.fillingFastIcon}
                      />
                      Filling Fast
                    </span>
                  ) : null}
                </label>
              );
            })}
          </div>
        </div>

        <div className={styles.confirmModalActions}>
          <button
            type="button"
            className={styles.confirmCancelButton}
            onClick={handleClose}
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.confirmSubmitButton}
            disabled={!selectedStartDate || isPending}
            onClick={() => onConfirm(batch, selectedStartDate)}
          >
            {isPending ? "Confirming..." : "Confirm Batch"}
          </button>
        </div>
      </div>
    </MuiDialog>
  );
};

export default ConfirmBatchModal;
